import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@portal/app/app.module';
import { environment } from '@portal/environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  Sentry.init({
    dsn: 'https://8c28b244614d385dbaaf58133a593d36@o4507861430501376.ingest.us.sentry.io/4507861436203008',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })
      // Note: feedbackIntegration removed - using custom FeedbackModalComponent with captureFeedback()
    ],
    enableLogs: true,
    tracesSampleRate: 0.1,
    propagateTraceparent: true,
    tracePropagationTargets: [environment.apiV2, environment.apiV1],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // Set profileSessionSampleRate to 1.0 to profile every session.
    // The profiling decision is made once per session when the SDK is initialized.
    // Note: Requires Document-Policy: js-profiling header from server for full functionality.
    profileSessionSampleRate: 1.0
  });
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
